/* Craftly: free scratch card in every order.

   A real product (0 ₪, SKU GIFT-SCRATCH) so it shows in checkout and reaches the
   supplier on the order. This script keeps exactly one in any cart that holds at
   least one other product, and removes it when nothing else is left, so a card can
   never be ordered on its own.

   It does not touch the 2+1 discount or the subscription:
   - the card is in no collection and carries the no-bogo tag, so neither the
     automatic 2+1 discount nor the 2+1 bar counts it (its id is also listed in the
     bar's data-excluded-products)
   - subscription lines are ignored here; clubFollowsProduct in craftly-cart-bogo.js
     still owns them. When it removes the last product, the next sync removes the card.
*/
(function(){
  if (window.__craftlyScratchGift) return;
  window.__craftlyScratchGift = true;
  // The subscription upsell loads /discount/MNUI_SUB_20 in a hidden iframe. That page
  // runs this script too; it must not touch the cart from there.
  try { if (window.top !== window.self) return; } catch(e){ return; }

  var CARD_PRODUCT = 15406805778531;
  var CARD_VARIANT = 67617515798627;
  var CARD_HANDLE  = 'scratch-card-gift';
  var RELOAD_KEY   = 'craftlyScratchReload';

  var syncing = false, timer = null;

  function isCard(it){ return it.product_id === CARD_PRODUCT; }
  // Anything that is shipped and is not the card itself. Gift cards are not shipped.
  function isReal(it){ return !isCard(it) && !it.gift_card; }
  function isCartPage(){ var tv = window.themeVariables; return !!(tv && tv.settings && tv.settings.pageType === 'cart'); }

  function post(url, body){
    return fetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function(r){ if (!r.ok) throw new Error(url + ' ' + r.status); return r.json(); });
  }
  function getCart(){ return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function(r){ return r.json(); }); }

  // Re-render the drawer and the header count the same way the theme's own controls do.
  // On the cart page the rows are server rendered, so reload once instead.
  function announce(){
    if (isCartPage()) {
      try { if (sessionStorage.getItem(RELOAD_KEY) === '1') return; sessionStorage.setItem(RELOAD_KEY, '1'); } catch(e){ return; }
      window.location.replace('/cart');
      return;
    }
    return getCart().then(function(cart){
      document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
    });
  }

  function sync(){
    if (syncing) return;
    // Let the subscription join finish applying its discount first (it watches the
    // cart and falls back to a full page redirect if it is slow), then add the card.
    if (document.querySelector('iframe[src*="/discount/"]')) { queueLater(); return; }
    syncing = true;
    getCart().then(function(cart){
      var items = cart.items || [];
      var cards = items.filter(isCard);
      var hasReal = items.some(isReal);
      if (hasReal && !cards.length) {
        return post('/cart/add.js', { items: [{ id: CARD_VARIANT, quantity: 1 }] }).then(announce);
      }
      if (!hasReal && cards.length) {
        var updates = {};
        cards.forEach(function(c){ updates[c.key] = 0; });
        return post('/cart/update.js', { updates: updates }).then(announce);
      }
      if (cards.length > 1 || (cards[0] && cards[0].quantity !== 1)) {
        var fix = {};
        cards.forEach(function(c, i){ fix[c.key] = i === 0 ? 1 : 0; });
        return post('/cart/update.js', { updates: fix }).then(announce);
      }
      // Cart is already right: the page we reloaded for is showing the final state.
      try { sessionStorage.removeItem(RELOAD_KEY); } catch(e){}
    }).catch(function(){}).then(function(){ syncing = false; });
  }

  function queueLater(){
    if (timer) clearTimeout(timer);
    timer = setTimeout(function(){ timer = null; sync(); }, 1500);
  }

  function queue(){
    if (timer) clearTimeout(timer);
    timer = setTimeout(function(){ timer = null; sync(); }, 450);
  }

  ['cart:refresh','cart:updated','cart:item-added','cart:item-removed','cart:build','on:cart:added','on:cart:updated','product:added']
    .forEach(function(n){ document.addEventListener(n, queue); });

  // Cart changes made without a theme event (other apps, quick add). Our own calls
  // carry the card variant id and are skipped, so this cannot feed itself.
  var origFetch = window.fetch;
  window.fetch = function(input, init){
    var url = (typeof input === 'string') ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    if (url && /\/cart\/(add|change|update|clear)/i.test(url)) {
      var body = init && init.body;
      // our updates use line keys, which start with the variant id, so this covers them too
      var ours = typeof body === 'string' && body.indexOf(String(CARD_VARIANT)) >= 0;
      if (!ours) p.then(queue).catch(function(){});
    }
    return p;
  };

  // ---------- Look of the card line (drawer + cart page) ----------
  function markLines(root){
    (root || document).querySelectorAll('.line-item').forEach(function(row){
      if (row.classList.contains('csg-line')) return;
      if (!row.querySelector('a[href*="/products/' + CARD_HANDLE + '"]')) return;
      row.classList.add('csg-line');
      // A plain product row: one subdued line under the title, styled like the
      // variant line other products show ("מגולגל ללא מסגרת / 30X40").
      row.querySelectorAll('.product-item-meta__title').forEach(function(t){
        if (t.nextElementSibling && t.nextElementSibling.classList.contains('csg-sub')) return;
        var s = document.createElement('span');
        // the cart page has a phone title and a desktop title; follow the same one
        s.className = 'csg-sub product-item-meta__property text--subdued text--xsmall'
                    + (t.classList.contains('hidden-phone') ? ' hidden-phone' : '')
                    + (t.classList.contains('hidden-tablet-and-up') ? ' hidden-tablet-and-up' : '');
        s.textContent = 'מתנה לכל הזמנה';
        t.parentNode.insertBefore(s, t.nextSibling);
      });
      // Write "חינם" inside each price list, so the theme's own phone / desktop
      // visibility still decides which one shows.
      row.querySelectorAll('.price-list').forEach(function(pl){
        pl.innerHTML = '<span class="csg-free">חינם</span>';
      });
    });
  }

  var st = document.createElement('style');
  st.textContent = ''
    + '.csg-line .csg-free{color:#1F7A21;font-weight:800}'
    + '.csg-line line-item-quantity,.csg-line .line-item__quantity,.csg-line .line-item__remove-button{display:none !important}';
  (document.head || document.documentElement).appendChild(st);

  var mo = new MutationObserver(function(){ markLines(document); });
  function start(){
    markLines(document);
    mo.observe(document.body, { childList: true, subtree: true });
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
